export const SWAP_BUTTON_CONNECT_WALLET = {
  id: 'CONNECT_WALLET',
  label: 'Connect Wallet',
};
export const SWAP_BUTTON_SELECT_TOKENS = {
  id: 'SELECT_TOKENS',
  label: 'Select tokens',
};
export const SWAP_BUTTON_FETCHING_PAIR = {
  id: 'FETCHING_PAIR',
  label: 'Fetching Pair...',
};
export const SWAP_BUTTON_PAIR_NOT_ESIST = {
  id: 'PAIR_NOT_ESIST',
  label: 'Pair does not exist',
};
export const SWAP_BUTTON_NOT_LIQUIDITY = {
  id: 'NOT_LIQUIDITY',
  label: 'not enough liquidity',
};
export const SWAP_BUTTON_ENTER_AMOUNT = {
  id: 'ENTER_AMOUNT',
  label: 'Enter amount',
};
export const SWAP_BUTTON_SWAP = {
  id: 'SWAP',
  label: 'SWAP',
};
